import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { AddToSlackButton } from '@/components/global/InstallSlack';
import { Button } from '@/components/ui/button';
import { resetSlackConfiguration } from '@/lib/queries/slack';
import { userQueries } from '@/lib/queries/user';

export const InstallSlackApp = (): JSX.Element => {
  const { data: userData } = useQuery(userQueries.current());
  const isSuperUser = userData?.superuser ?? false;
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <section>
      <h1 className="text-xl mb-2">
        <FormattedMessage id="configuration.slackApp.title" />
      </h1>
      <div className="flex items-center gap-2">
        <AddToSlackButton variant="main" />
        {isSuperUser && (
          <Button
            variant="destructive"
            className="text-white"
            type="button"
            onClick={() => {
              void (async () => {
                await resetSlackConfiguration();
                await queryClient.clear();
                await navigate({
                  to: '/',
                });
              })();
            }}
          >
            Reset Slack Configuration
          </Button>
        )}
      </div>
    </section>
  );
};
